<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col v-if="error !== null" cols="12" lg="5" md="6">
        <v-card>
          <v-card-title>
            {{ $t("manager.moderation.errors.token_expiration.title") }}
          </v-card-title>
          <v-card-text>
            <v-container>
              <p>{{ $t("manager.moderation.errors.token_expiration.message") }}</p>
              <a class="blue--text text-decoration-underline" href="/">{{
                $t("manager.moderation.errors.token_expiration.link")
              }}</a>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col v-if="review.hasOwnProperty('id')" cols="12" lg="5" md="6">
        <Review
          :key="key('review')"
          :review="review"
          without-token="true"
          @remove="remove"
          @rollback="rollback"
        ></Review>
        <ResponseImpersonate
          :key="key('response')"
          :response="review.response"
          :review="review"
          :token="token"
          @confidence="confidence"
          @moderate="review.moderate = 1"
          @remove="removeResponse"
          @rollback="rollback"
        ></ResponseImpersonate>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { unobservable } from "../../../helpers"
import Review from "../tabs/Reviews/Review"
import ResponseImpersonate from "../tabs/Reviews/ResponseImpersonate"
import { Types as TypesSnackbar } from "../../../store/modules/snackbar"

export default {
  name: "ModerationToken",
  components: {
    Review,
    ResponseImpersonate,
  },
  data: () => ({
    error: null,
    review: {},
    snapshotReview: {},
  }),
  mounted() {
    this.fetchReview()
  },
  computed: {
    token() {
      return this.$route.params.token
    },
  },
  methods: {
    confidence: function(value) {
      this.review.confidence = value
    },
    key(name) {
      return `${name}.${this.review.id}.${this.review.database}`
    },
    fetchReview() {
      this.error = null
      this.$axios
        .get("office/manager/impersonate/review/", {
          params: {
            token: this.token,
          },
        })
        .then(response => {
          this.review = response.data
          if (this.review.response === null) {
            this.review.response = {
              message: "",
            }
          }
          this.snapshotReview = unobservable(this.review)
        })
        .catch(error => {
          this.error = error
        })
    },
    showDeadlockMessage(deadlock) {
      this.$store.dispatch(TypesSnackbar.actions.PUSH_MESSAGE, {
        lines: this.$t("dashboard.reviewsModeration.deadlock", {
          date: this.$moment(deadlock.created_at).from(),
        }),
        config: { timeout: 1000 * 10, color: "error" },
      })
    },
    rollback() {
      this.review = unobservable(this.snapshotReview)
    },
    remove() {
      this.reviews = this.reviews.filter(r => r.id + r.database !== this.review.id + this.review.database)

      this.review = {}
    },
    removeResponse() {
      let index = this.reviews.findIndex(r => r.id + r.database === this.review.id + this.review.database)

      this.review.moderate = 0
      this.review.response = { message: "" }
      this.reviews[index].moderate = 0
    },
  },
}
</script>
